import React, { useEffect, useState, useContext, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../../RedirectCode400";
import Breadcrumb from "../breacrumb/breadcrumb";
import HeadBar from "../headBar/HeadBar";
import Footer from "../footer/Footer";
import * as publicApi from "../../../service/publicApi";
import logo__home from "../../../asset/image/logo.svg";
import news1 from "../../../asset/image/new/news1.png";
import news2 from "../../../asset/image/new/news2.png";
import news3 from "../../../asset/image/new/news3.png";
import news4 from "../../../asset/image/new/news4.png";
import article3 from "../../../asset/image/new/article3.png";
import style from "./Content.module.css";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { CurrentUserContext } from "../../../App";

const News = [
  {
    url: `${news1}`,
    time: "13 ม.ค. 67",
    name: "การจัดอบรมฟื้นฟูองค์ความรู้ และเสริมสร้างความเข้มแข็ง",
    isNew: true,
  },
  {
    url: `${news2}`,
    time: "13 ม.ค. 67",
    name: "การจัดอบรมฟื้นฟูองค์ความรู้ และเสริมสร้างความเข้มแข็ง",
    isNew: false,
  },
  {
    url: `${news3}`,
    time: "13 ม.ค. 67",
    name: "การจัดอบรมฟื้นฟูองค์ความรู้ และเสริมสร้างความเข้มแข็ง",
    isNew: false,
  },
  {
    url: `${news4}`,
    time: "13 ม.ค. 67",
    name: "การจัดอบรมฟื้นฟูองค์ความรู้ และเสริมสร้างความเข้มแข็ง",
    isNew: false,
  },
];

function ContentDetail({ disabledMenu }) {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const { content_id } = useParams();

  const [loading, setLoading] = useState(false);
  const [dataTitle, setDataTitle] = useState("");

  const [contentDetail, setContentDetail] = useState([]);

  let params = useParams();

  const [selectedImages, setSelectedImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const openModal = (images, index, e) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    const gallery = images || [];
    
    setSelectedImages(gallery);
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const nextImage = (e) => {
    if (e) e.stopPropagation();
    setCurrentIndex((prev) => (prev + 1) % selectedImages.length);
  };

  const prevImage = (e) => {
    if (e) e.stopPropagation();
    setCurrentIndex((prev) => (prev - 1 + selectedImages.length) % selectedImages.length);
  };

  const getContentDetail = useCallback(async () => {
    setLoading(true);
    let res = await publicApi.getContentDetail(content_id);

    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setContentDetail(res["data"]["content_data"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  }, [content_id, navigate, setIsMessage]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getContentDetail();
    if (params.slug === "news") {
      setDataTitle("ประชาสัมพันธ์");
    } else if (params.slug === "article") {
      setDataTitle("บทความ");
    } else if (params.slug === "announcement") {
      setDataTitle("ประกาศ");
    } else {
      navigate(RedirectCode400());
    }
  }, [getContentDetail, navigate, params.slug]);

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: dataTitle, url: `/${params.slug}` },
    { name: contentDetail.title, url: "#" },
  ];

  // const dataNews = {
  //   img1: `${news1}`,
  //   img2: `${article3}`,
  //   title:
  //     "การจัดอบรมฟื้นฟูองค์ความรู้และเสริมสร้างความเข้มแข็งเพิ่มศักยภาพเครือข่ายห้องปฏิบัติการตรวจวินิจฉัยธาลัสซีเมีย",
  //   description:
  //     " เมื่อวันที่ 23 สิงหาคม 2567 ศูนย์ปฎิบัติการตรวจคัดกรองสุขภาพทารกแรกเกิด แห่งชาติ สถาบันชีววิทยาศาสตร์ทางการแพทย์ ได้มีการจัดอบรมฟื้นฟูองค์ความรู้และเสริมสร้างความเข้มแข็งเพิ่มศักยภาพเครือข่ายห้องปฏิบัติการตรวจวินิจฉัยราลัสซีเมีย ในรูปแบบ Online เพื่อให้บุคลากรเครื่อข่ายห้องปฏิบัติการการตรวจ วินิจฉัยธาลัสซีเมีย ได้รับการฟื้นฟูองค์ความรู้ และพัฒนาความรู้ในด้านการตรวจ วินิจฉัยด้วยเทคโนโลยีใหม่ โดยได้รับเกียรติจากอาจารย์สถาบันชีววิทยาศาสตร์ โมเลกุล มหาวิทยาลัยมหิดล มาบรรยายเกี่ยวกับการตรวจวินิจฉัยราลัสซีเมีย มี",
  // };
  return (
    <>
      <div className="global-page">
        {/* {disabledMenu ? null : <HeadBar menu={"news"} />} */}
        <Breadcrumb pathItems={pathItems} />

        <div className="w-full flex flex-col justify-center items-center my-[4rem] gap-6">
          <div className="lg:!w-auto w-[730px]">
            <h1 className="text-[1.5rem]">{contentDetail.title}</h1>
            <div className="w-full h-auto mt-[4rem]">
              <img src={contentDetail.thumbnail} alt="" className="w-full" />
              <div
                className="text-[1.2rem] my-6"
                dangerouslySetInnerHTML={{ __html: contentDetail.description }}
              ></div>
              {contentDetail && contentDetail.file ? (
                <>
                  <a
                    href={contentDetail.file}
                    target="_blank"
                    download
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      textDecoration: "none",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.children[1].style.textDecoration =
                        "underline")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.children[1].style.textDecoration =
                        "none")
                    }
                  >
                    <span style={{ fontSize: "24px" }}>
                      <FontAwesomeIcon
                        icon={faFilePdf}
                        style={{ fontSize: "24px" }}
                        color="red"
                      />
                    </span>
                    <span>เอกสาร</span>
                  </a>
                </>
              ) : null}

              {contentDetail.illustration && contentDetail.illustration.length > 0 && (
                <h1 className="text-[1.25rem] mt-2">รูปประกอบ</h1>
              )}
              {contentDetail.illustration && contentDetail.illustration.length > 0 && (
                <div className="grid grid-cols-4 md:grid-cols-3 2sm:grid-cols-2 gap-4 my-8">
                  {contentDetail.illustration.map((img, idx) => (
                    <div key={idx} className="aspect-video overflow-hidden rounded-lg shadow-sm border">
                      <img 
                        src={img} 
                        alt={`illustration-${idx}`} 
                        className="w-full h-full object-cover cursor-zoom-in hover:scale-105 transition-transform duration-300"
                        onClick={(e) => openModal(contentDetail.illustration, idx, e)}
                      />
                    </div>
                  ))}
                </div>
              )}

              <img src={contentDetail.img2} alt="" className="w-full" />
            </div>
          </div>
        </div>

        {params.slug !== "announcement" && (
          <RecommendContent contentId={content_id} />
        )}
      </div>

      {isOpen && selectedImages.length > 0 && (
        <div 
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-90 p-4 backdrop-blur-sm"
          onClick={() => setIsOpen(false)}
        >
          <button className="absolute top-5 right-5 text-white text-4xl hover:text-gray-400 z-[10000]">✕</button>

          {selectedImages.length > 1 && (
            <button 
              className="absolute left-4 md:left-10 text-white bg-white/10 p-4 rounded-full hover:bg-white/20 z-[10000]"
              onClick={(e) => prevImage(e)}
            >
              ❮
            </button>
          )}

          <div className="relative max-w-5xl w-full flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImages[currentIndex]}
              className="max-h-[85vh] max-w-full object-contain rounded shadow-2xl transition-all duration-300"
              alt="Preview"
            />
            <div className="text-white mt-4 bg-black/50 px-6 py-2 rounded-full text-sm">
              {currentIndex + 1} / {selectedImages.length}
            </div>
          </div>

          {selectedImages.length > 1 && (
            <button 
              className="absolute right-4 md:right-10 text-white bg-white/10 p-4 rounded-full hover:bg-white/20 z-[10000]"
              onClick={(e) => nextImage(e)}
            >
              ❯
            </button>
          )}
        </div>
      )}
    </>
  );
}

export default ContentDetail;

function RecommendContent({ contentId }) {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const convertToThaiDate = (dateString) => {
    const thaiMonths = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];

    const date = new Date(dateString);
    const day = date.getDate();
    const month = thaiMonths[date.getMonth()];
    const year = date.getFullYear() + 543;

    return `${day} ${month} ${year}`;
  };
  const [newsList, setNewsList] = useState([]);
  let params = useParams();

  const getNewsList = useCallback(async () => {
    let body = {
      content_id: contentId,
      type: params.slug,
      page: 1,
      number_per_page: 4,
      sort: {
        publish_start_date: -1,
      },
    };
    setLoading(true);
    let res = await publicApi.getContentList(body);
    setLoading(false);
    // console.log(res);
    if (res) {
      if (res["data"]["code"] === 200) {
        setNewsList(res["data"]["content_list"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  }, [contentId, navigate, params.slug, setIsMessage]);

  useEffect(() => {
    getNewsList();
  }, [getNewsList]);

  return (
    <>
      <div className="xl:text-2xl text-3xl font-bold">คุณอาจสนใจ</div>
      <div className="xsm:flex xsm:flex-col sm:gap-4 lg:grid-cols-2 grid grid-flow-dense grid-cols-4 gap-4 my-4">
        {newsList.map((news, index) => (
          <div
            key={index}
            className="flex flex-col items-center h-full cursor-pointer"
            onClick={() => navigate(`/news/${news.content_id}`)}
          >
            <div className="aspect-[22/21] overflow-hidden w-full h-[270px] rounded-md cursor-pointer">
              <img
                className="w-full object-cover transition-transform duration-300 rounded-lg hover:scale-110"
                src={news.thumbnail ? news.thumbnail : logo__home}
                alt="thumbnail"
              />
            </div>
            <div className="flex flex-col items-center w-full py-3">
              {index == 0 && (
                <div className="flex px-1 pt-3 w-full">
                  <div className="lg:text-[8px] lg:px-3 flex text-start px-4 py-1 text-[10px] text-white bg-red-500 rounded-[25px]">
                    New Update
                  </div>
                </div>
              )}
              <span className="lg:text-xs px-1 py-3 w-full text-sm text-gray-500">
                โพสต์เมื่อ {convertToThaiDate(news.publish_start_date.date)}
              </span>
              <span
                className={`xl:text-base px-1 w-full text-lg font-bold ${style.truncate}`}
              >
                {news.title}
              </span>
              <span
                className="p-1 w-full text-sm underline cursor-pointer text-[#FF9768]"
                onClick={() => navigate(`/news/${news.content_id}`)}
              >
                อ่านเพิ่มเติม
              </span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
